export const navList = [
  {
    title: '调节模块',
    subTitle: 'Adjustment Module',
    content: '调节模块训练',
    path: '/home/shopTrain',
    img: 'images/rs.png',
    bgColor: '#20ca72',
    bgImage: 'images/rs-bg.png',
    key: 0,
    trainArray: [{ name: '调节训练', type: 'ACC' }],
  },
  {
    title: '增视模块',
    subTitle: 'Vision Enhancement Module',
    content: '增视模块训练',
    path: '/home/shopTrain',
    img: 'images/sgn.png',
    bgColor: '#ffca30',
    bgImage: 'images/rsxs-bg.png',
    key: 1,
    trainArray: [
      { name: '刺激训练', type: 'ST' },
      { name: '精细训练', type: 'EX' },
    ],
  },
  {
    title: '对比敏感度',
    subTitle: 'Contrast Sensitivity',
    content: '对比敏感度训练',
    path: '/home/shopTrain',
    img: 'images/ksjc.png',
    bgColor: '#fb5fc4',
    bgImage: 'images/sgn-bg.png',
    key: 2,
    trainArray: [
      { name: '对比敏感度', type: 'DBM' },
      { name: 'Gabor训练', type: 'GB' },
    ],
  },
  {
    title: '视功能模块',
    subTitle: 'Visual Function Module',
    content: '视功能模块训练',
    path: '/home/shopTrain',
    img: 'images/movie.png',
    bgColor: '#25aeff',
    bgImage: 'images/movie-bg.png',
    key: 3,
    trainArray: [
      { name: '同时视训练', type: 'SV' },
      { name: '融合视训练', type: 'FU' },
      { name: '立体视训练', type: 'STE' },
    ],
  },
]
export const trainType = [
  { name: '调节训练', type: 'ACC' },
  { name: '精细训练', type: 'EX' },
  { name: '刺激训练', type: 'ST' },
  { name: '对比敏感度', type: 'DBM' },
  { name: 'Gabor训练', type: 'GB' },
  { name: '同时视训练', type: 'SV' },
  { name: '融合视训练', type: 'FU' },
  { name: '立体视训练', type: 'STE' },
]
export const movies = [
  {
    title: '3D短片',
    data: [
      {
        src: 'https://files.babyeye.com/Asahiyama%20Zoo.mp4',
        cover:
          'https://files.babyeye.com/video/sdx/%E5%8A%A8%E7%89%A9%E4%B8%96%E7%95%8C.jpg',
        name: '走进动物园',
      },
    ],
  },
  {
    title: '龙之谷',
    data: [
      {
        src: 'https://files.babyeye.com/video/vr/dragon.nest.warriors01.mp4',
        cover: 'https://files.babyeye.com/video/sdx/long01.jpg',
        name: 'part-01',
      },
      {
        src: 'https://files.babyeye.com/video/vr/dragon.nest.warriors02.mp4',
        cover: 'https://files.babyeye.com/video/sdx/long02.jpg',
        name: 'part-02',
      },
      {
        src: 'https://files.babyeye.com/video/vr/dragon.nest.warriors03.mp4',
        cover: 'https://files.babyeye.com/video/sdx/long03.jpg',
        name: 'part-03',
      },
      {
        src: 'https://files.babyeye.com/video/vr/dragon.nest.warriors04.mp4',
        cover: 'https://files.babyeye.com/video/sdx/long04.jpg',
        name: 'part-04',
      },
      {
        src: 'https://files.babyeye.com/video/vr/dragon.nest.warriors05.mp4',
        cover: 'https://files.babyeye.com/video/sdx/long05.jpg',
        name: 'part-05',
      },
    ],
  },
  {
    title: '逗鸟外传',
    data: [
      {
        src: 'https://files.babyeye.com/video/vr/storks01.mp4',
        cover: 'https://files.babyeye.com/video/sdx/niao01.jpg',
        name: 'part-01',
      },
      {
        src: 'https://files.babyeye.com/video/vr/storks02.mp4',
        cover: 'https://files.babyeye.com/video/sdx/niao02.jpg',
        name: 'part-02',
      },
      {
        src: 'https://files.babyeye.com/video/vr/storks03.mp4',
        cover: 'https://files.babyeye.com/video/sdx/niao03.jpg',
        name: 'part-03',
      },
      {
        src: 'https://files.babyeye.com/video/vr/storks04.mp4',
        cover: 'https://files.babyeye.com/video/sdx/niao04.jpg',
        name: 'part-04',
      },
      {
        src: 'https://files.babyeye.com/video/vr/storks05.mp4',
        cover: 'https://files.babyeye.com/video/sdx/niao05.jpg',
        name: 'part-05',
      },
    ],
  },
]
